import QuillImageDropAndPaste from 'quill-image-drop-and-paste';
import { UnhDialog } from './../../services/unh-dialog.service';
import { EmbedVideoService } from 'ngx-embed-video';
import { RestApiService } from '@frontend/unhideschool/app/api-gateway/services/rest-api.service';
import { QuillModules } from 'ngx-quill';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { Output, EventEmitter, Input, Component, ChangeDetectorRef } from '@angular/core';
import Quill from 'quill';
import { filter } from 'rxjs/operators';

Quill.register('modules/imageDropAndPaste', QuillImageDropAndPaste);

const baseImageFormat = Quill.import('formats/image');
baseImageFormat.sanitize = url => url;

export interface imageQuillDTO {
  blobUrl: string;
  file: File;
}
@Component({
  template: '',
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class CustomQuillBase {
  currentContent;

  @Input() readonly = false;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onImagesChanged = new EventEmitter();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onEditorChanged = new EventEmitter();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onEditorCreated = new EventEmitter();

  imageQuillDTO = new BehaviorSubject<imageQuillDTO[]>([]);

  inputAutoFocus = new BehaviorSubject(false);

  QuillModules: QuillModules = {
    toolbar: {
      container: [['link', 'image', 'video']],
      handlers: {
        link: (e) => {
          const selection = this.quillEditorRef.getSelection();
          if (selection.length > 1) {
            this.selection = selection;
          } else {
            this.index = selection.index;
          }
          this.clickedType = 'link';
          this.inputAutoFocus.next(true);
        },
        image: (e) => {
          const selection = this.quillEditorRef.getSelection();
          this.imageHandler(e,selection);
        },
        video: (e) => {
          const selection = this.quillEditorRef.getSelection();
          if (selection.length > 1) {
            this.selection = selection;
          } else {
            this.index = selection.index;
          }
          this.clickedType = 'video';
          this.inputAutoFocus.next(true);

        }
      }
    },
    imageDropAndPaste: {
      // add an custom image handler


      handler: (imageDataUrl, type, imageData) => {
        const selection = this.quillEditorRef.getSelection();
        return this.imagePasteHandler(imageDataUrl , type , imageData , this.quillEditorRef, selection)
      }

    }
  }

    quillEditorRef = null;
    clickedType: string;

    popupValue: string;

    index;
    selection;

  cdr2 = this.cdr;

    constructor(
      private capis: RestApiService,
      private embedService: EmbedVideoService,
      private cdr: ChangeDetectorRef,
      private unhd: UnhDialog
    ) {

  }
  imagePasteHandler(imageDataUrl, type, imageData, editorRef, selection) {
    const file = imageData.toFile();
    const url = (URL || webkitURL).createObjectURL(file);

    editorRef.insertEmbed(selection.index, 'image', url);
    const oldImages = this.imageQuillDTO.value;
    const updatedImages = [...oldImages, { file, blobUrl: url }];
    this.imageQuillDTO.next(updatedImages);
  }

  onTextChanged(e: any) {
    if (e.event === 'text-change') {
      this.currentContent = e.html;
      const oldImages = this.imageQuillDTO.value;
      //verifica se retirou alguma imagem
      const filteredImages = oldImages.filter(image => {
        const text = e.html;
        return text && text.includes(image.blobUrl);
      });
      this.imageQuillDTO.next(filteredImages);
      this.onEditorChanged.emit(e);
    }
  }

  getQuillInstance(quillEditorRef) {
    this.quillEditorRef = quillEditorRef;
    this.onEditorCreated.emit(quillEditorRef);
  }

  getEmbedOrLinkValue(inputValue) {
    this.popupValue = inputValue;
  }

  getEmbedOrLink(clickedType) {
    switch (clickedType) {
      case 'video': {
        this.videoHandler(this.popupValue);
        break;
      }
      case 'link': {
        this.linkHandler(this.popupValue);
      }
    }
    this.close();
  }

  linkHandler(url) {
    let text;
    if (this.validateLinkUrl(url)) {
      if (this.selection && this.selection.length > 0) {
        text = this.quillEditorRef.getText(this.selection.index, this.selection.length);
        this.quillEditorRef.deleteText(this.selection.index, this.selection.length);
        this.quillEditorRef.insertText(this.selection.index, text, 'link', url);
      } else {
        this.quillEditorRef.insertText(this.index, url, 'link', url);
      }
    } else {
      this.unhd.confirm({
        text: {
          title: 'Ops, Link inválido.',
          // message: 'Deseja mesmo fazer isso?'
        }
      }).subscribe();
    }
  }

  validateLinkUrl(url) {
    const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    if (url.match(pattern)) {
      return true;
    } else {
      return false;
    }
  }

  uploadImage(file) {
    const data = new FormData();
    data.append('file', file, file.name);
    data.append('mediacontenttype', 'communitymediaitem');
    this.capis.upload<any>('/media/uploadfile', data).pipe(
      filter(res => res != null)
    ).subscribe((res) => {
      if (res.status === 'complete') {
        this.quillEditorRef.insertEmbed(this.index, 'image', res.message.dict.urlimage);
        this.quillEditorRef.updateContents();
      }
    });
  }

  /* blob file */
  imageHandler(e, selection) {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/x-png,image/gif,image/jpeg,image/jpg';
    input.click();
    fromEvent(input, 'change').subscribe((event: any) => {
      const file = event.target.files[0];
      const url = (URL || webkitURL).createObjectURL(file);
      this.quillEditorRef.insertEmbed(selection.index, 'image', url);
      let oldImages = this.imageQuillDTO.value;
      const index = oldImages.findIndex(image => image.blobUrl == url);
      let nValue;
      if (index == -1) {
        oldImages.push({
          blobUrl: url,
          file: file
        });
        nValue = oldImages
      } else {
        const temp = {
          blobUrl: url,
          file: file
        }
        nValue = [oldImages.slice(0, index), temp, ...oldImages.slice(index + 1)]
      }

      //verifica se retirou alguma imagem
      oldImages = oldImages.filter(image => {
        const text = this.currentContent;
        return text.includes(image?.blobUrl);
      })
      // retorna novo estado
      this.imageQuillDTO.next(nValue);
    });
    this.close();
  }

  videoHandler(videoCode) {
    // const selection = this.quillEditorRef.getSelection();
    // const index = (selection || {}).index || this.quillEditorRef.getLength() - 1;
    if (this.validateVideoUrl(videoCode)) {
      videoCode = videoCode.replace(/(.*)v=([^&]*)(.*)/, '$1v=$2');
      const embed = this.embedService.embed(videoCode);
      const iframe = document.createElement('div');
      iframe.innerHTML = embed.changingThisBreaksApplicationSecurity;
      videoCode = iframe.firstElementChild.attributes.getNamedItem('src').value;
      this.quillEditorRef.insertEmbed(this.index, 'video', videoCode);

    }
  }

  // HELPER
  validateVideoUrl(url) {
    const ytUrl = 'youtube.com';
    const vUrl = 'vimeo.com';
    const validUrl =
      url.includes(ytUrl) ||
      url.includes(vUrl);

    return validUrl;
  }

  close() {
    this.clickedType = null;
    this.popupValue = null;
    this.selection = null;
    this.index = null;
    this.inputAutoFocus.next(false);
  }
}
